import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import * as tracking from '../tracking';

const mutation = graphql`
	mutation updateViewerMutationModernMutation($input: UpdateViewerInput!) {
		updateViewer(input: $input) {
			errors
			viewer {
				email
				jobTitle
				department {
					id
					name
				}
				firstName
				lastName
				phone
				initials
				cost
				profile {
					id
					name
				}
				role {
					id
					name
				}
				holidayCalendar {
					id
				}
				language
				invited
				profilePictureId
				personLabels(first: 10000) {
					edges {
						node {
							label {
								id
								name
								color
							}
						}
					}
				}
				unseenNotifications
				notificationFrequency
				notifyOnPersonJoin
				notifyOnProjectStatusChange
				notifyOnAssignedProject
				notifyOnProjectDeadline
				notifyOnAssignedTask
				notifyOnAssignedTaskUpdate
				notifyOnTaskDeadline
				notifyOnMention
				notifyOnTaskDescriptionChange
				notifyOnTaskTitleChange
				notifyOnTaskEstimateChange
				notifyOnTaskStartDateChange
				notifyOnTaskEndDateChange
				notifyOnTaskSprintChange
				notifyOnTaskPhaseChange
				notifyOnTaskStatusColumnChange
				notifyOnTaskProjectChange
				notifyOnTaskSubtaskChange
				notifyOnTaskSubtaskEstimateChange
				notifyOnTaskCommentChange
				notifyOnTaskFileChange
				notifyOnTaskBugChange
				notifyOnTaskBlockedChange
				notifyOnTaskRepeatingChange
				disableNotifications
				projectDeadlineNotificationPeriod
				taskDeadlineNotificationPeriod
				notifyInAppOnProjectStatusChange
				notifyInAppOnPersonJoin
				notifyInAppOnAssignedProject
				notifyInAppOnProjectDeadline
				notifyInAppOnAssignedTask
				notifyInAppOnAssignedTaskUpdate
				notifyInAppOnTaskDeadline
				notifyInAppOnMention
				notifyInAppOnTaskDescriptionChange
				notifyInAppOnTaskTitleChange
				notifyInAppOnTaskEstimateChange
				notifyInAppOnTaskStartDateChange
				notifyInAppOnTaskEndDateChange
				notifyInAppOnTaskSprintChange
				notifyInAppOnTaskPhaseChange
				notifyInAppOnTaskStatusColumnChange
				notifyInAppOnTaskProjectChange
				notifyInAppOnTaskSubtaskChange
				notifyInAppOnTaskSubtaskEstimateChange
				notifyInAppOnTaskCommentChange
				notifyInAppOnTaskFileChange
				notifyInAppOnTaskBugChange
				notifyInAppOnTaskBlockedChange
				notifyInAppOnTaskRepeatingChange
				disableInAppNotifications
				projectDeadlineInAppNotificationPeriod
				taskDeadlineInAppNotificationPeriod
				lastSeenInAppNotification
				sendNewsletter
				monday
				tuesday
				wednesday
				thursday
				friday
				saturday
				sunday
				startDate
				endDate
				timerStartDate
				timerEndDate
				timerTask {
					id
				}
				setToRunningNotificationLastDismissalDate
				timeLogUser {
					integrationUserId
				}
				gitlabUser {
					integrationUserId
				}
				gitlabServerUser {
					integrationUserId
				}
				githubUser {
					integrationUserId
				}
				unit4UserObject
				jiraCloudId
				jiraServerId
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function getOptimisticResponse(input) {
	const obj = {id: input.id};
	if (input.email) {
		obj.email = input.email;
	}
	if (input.jobTitle) {
		obj.jobTitle = input.jobTitle;
	}
	if (input.firstName) {
		obj.firstName = input.firstName;
	}
	if (input.lastName) {
		obj.lastName = input.lastName;
	}
	if (input.phone) {
		obj.phone = input.phone;
	}
	if (input.initials) {
		obj.initials = input.initials;
	}
	if (input.userType) {
		obj.userType = input.userType;
	}
	if (input.roleId) {
		obj.roleId = input.roleId;
	}
	if (input.profileId) {
		obj.profileId = input.profileId;
	}
	if (input.departmentId) {
		obj.departmentId = input.departmentId;
	}
	if (input.holidayCalendarId) {
		obj.holidayCalendar = {id: input.holidayCalendarId};
	}
	if (input.notificationFrequency !== undefined) {
		obj.notificationFrequency = input.notificationFrequency;
	}
	if (input.notifyOnPersonJoin !== undefined) {
		obj.notifyOnPersonJoin = input.notifyOnPersonJoin;
	}
	if (input.notifyOnProjectStatusChange !== undefined) {
		obj.notifyOnProjectStatusChange = input.notifyOnProjectStatusChange;
	}
	if (input.notifyOnAssignedProject !== undefined) {
		obj.notifyOnAssignedProject = input.notifyOnAssignedProject;
	}
	if (input.notifyOnProjectDeadline !== undefined) {
		obj.notifyOnProjectDeadline = input.notifyOnProjectDeadline;
	}
	if (input.notifyOnAssignedTask !== undefined) {
		obj.notifyOnAssignedTask = input.notifyOnAssignedTask;
	}
	if (input.notifyOnAssignedTaskUpdate !== undefined) {
		obj.notifyOnAssignedTaskUpdate = input.notifyOnAssignedTaskUpdate;
	}
	if (input.notifyOnTaskDeadline !== undefined) {
		obj.notifyOnTaskDeadline = input.notifyOnTaskDeadline;
	}
	if (input.notifyOnMention !== undefined) {
		obj.notifyOnMention = input.notifyOnMention;
	}
	if (input.notifyOnTaskDescriptionChange !== undefined) {
		obj.notifyOnTaskDescriptionChange = input.notifyOnTaskDescriptionChange;
	}
	if (input.notifyOnTaskTitleChange !== undefined) {
		obj.notifyOnTaskTitleChange = input.notifyOnTaskTitleChange;
	}
	if (input.notifyOnTaskEstimateChange !== undefined) {
		obj.notifyOnTasEstimateChange = input.notifyOnTaskEstimateChange;
	}
	if (input.notifyOnTaskStartDateChange !== undefined) {
		obj.notifyOnTaskStartDateChange = input.notifyOnTaskStartDateChange;
	}
	if (input.notifyOnTaskEndDateChange !== undefined) {
		obj.notifyOnTaskEndDateChange = input.notifyOnTaskEndDateChange;
	}
	if (input.notifyOnTaskSprintChange !== undefined) {
		obj.notifyOnTaskSprintChange = input.notifyOnTaskSprintChange;
	}
	if (input.notifyOnTaskPhaseChange !== undefined) {
		obj.notifyOnTaskPhaseChange = input.notifyOnTaskPhaseChange;
	}
	if (input.notifyOnTaskStatusColumnChange !== undefined) {
		obj.notifyOnTaskStatusColumnChange = input.notifyOnTaskStatusColumnChange;
	}
	if (input.notifyOnTaskProjectChange !== undefined) {
		obj.notifyOnTaskProjectChange = input.notifyOnTaskProjectChange;
	}
	if (input.notifyOnTaskSubtaskChange !== undefined) {
		obj.notifyOnTaskSubtaskChange = input.notifyOnTaskSubtaskChange;
	}
	if (input.notifyOnTaskSubtaskEstimateChange !== undefined) {
		obj.notifyOnTaskSubtaskEstimateChange = input.notifyOnTaskSubtaskEstimateChange;
	}
	if (input.notifyOnTaskCommentChange !== undefined) {
		obj.notifyOnTaskCommentChange = input.notifyOnTaskCommentChange;
	}
	if (input.notifyOnTaskFileChange !== undefined) {
		obj.notifyOnTaskFileChange = input.notifyOnTaskFileChange;
	}
	if (input.notifyOnTaskBugChange !== undefined) {
		obj.notifyOnTaskBugChange = input.notifyOnTaskBugChange;
	}
	if (input.notifyOnTaskBlockedChange !== undefined) {
		obj.notifyOnTaskBlockedChange = input.notifyOnTaskBlockedChange;
	}
	if (input.notifyOnTaskRepeatingChange !== undefined) {
		obj.notifyOnTaskRepeatingChange = input.notifyOnTaskRepeatingChange;
	}
	if (input.disableNotifications) {
		obj.disableNotifications = input.disableNotifications;
	}
	if (input.notifyInAppOnProjectStatusChange !== undefined) {
		obj.notifyInAppOnProjectStatusChange = input.notifyInAppOnProjectStatusChange;
	}
	if (input.notifyInAppOnAssignedProject !== undefined) {
		obj.notifyInAppOnAssignedProject = input.notifyInAppOnAssignedProject;
	}
	if (input.notifyInAppOnPersonJoin !== undefined) {
		obj.notifyInAppOnPersonJoin = input.notifyInAppOnPersonJoin;
	}
	if (input.notifyInAppOnProjectDeadline !== undefined) {
		obj.notifyInAppOnProjectDeadline = input.notifyInAppOnProjectDeadline;
	}
	if (input.notifyInAppOnAssignedTask !== undefined) {
		obj.notifyInAppOnAssignedTask = input.notifyInAppOnAssignedTask;
	}
	if (input.notifyInAppOnAssignedTaskUpdate !== undefined) {
		obj.notifyInAppOnAssignedTaskUpdate = input.notifyInAppOnAssignedTaskUpdate;
	}
	if (input.notifyInAppOnTaskDeadline !== undefined) {
		obj.notifyInAppOnTaskDeadline = input.notifyInAppOnTaskDeadline;
	}
	if (input.notifyInAppOnMention !== undefined) {
		obj.notifyInAppOnMention = input.notifyInAppOnMention;
	}
	if (input.notifyInAppOnTaskDescriptionChange !== undefined) {
		obj.notifyInAppOnTaskDescriptionChange = input.notifyInAppOnTaskDescriptionChange;
	}
	if (input.notifyInAppOnTaskTitleChange !== undefined) {
		obj.notifyInAppOnTaskTitleChange = input.notifyInAppOnTaskTitleChange;
	}
	if (input.notifyInAppOnTaskEstimateChange !== undefined) {
		obj.notifyInAppOnTasEstimateChange = input.notifyInAppOnTaskEstimateChange;
	}
	if (input.notifyInAppOnTaskStartDateChange !== undefined) {
		obj.notifyInAppOnTaskStartDateChange = input.notifyInAppOnTaskStartDateChange;
	}
	if (input.notifyInAppOnTaskEndDateChange !== undefined) {
		obj.notifyInAppOnTaskEndDateChange = input.notifyInAppOnTaskEndDateChange;
	}
	if (input.notifyInAppOnTaskSprintChange !== undefined) {
		obj.notifyInAppOnTaskSprintChange = input.notifyInAppOnTaskSprintChange;
	}
	if (input.notifyInAppOnTaskPhaseChange !== undefined) {
		obj.notifyInAppOnTaskPhaseChange = input.notifyInAppOnTaskPhaseChange;
	}
	if (input.notifyInAppOnTaskStatusColumnChange !== undefined) {
		obj.notifyInAppOnTaskStatusColumnChange = input.notifyInAppOnTaskStatusColumnChange;
	}
	if (input.notifyInAppOnTaskProjectChange !== undefined) {
		obj.notifyInAppOnTaskProjectChange = input.notifyInAppOnTaskProjectChange;
	}
	if (input.notifyInAppOnTaskSubtaskChange !== undefined) {
		obj.notifyInAppOnTaskSubtaskChange = input.notifyInAppOnTaskSubtaskChange;
	}
	if (input.notifyInAppOnTaskSubtaskEstimateChange !== undefined) {
		obj.notifyInAppOnTaskSubtaskEstimateChange = input.notifyInAppOnTaskSubtaskEstimateChange;
	}
	if (input.notifyInAppOnTaskCommentChange !== undefined) {
		obj.notifyInAppOnTaskCommentChange = input.notifyInAppOnTaskCommentChange;
	}
	if (input.notifyInAppOnTaskFileChange !== undefined) {
		obj.notifyInAppOnTaskFileChange = input.notifyInAppOnTaskFileChange;
	}
	if (input.notifyInAppOnTaskBugChange !== undefined) {
		obj.notifyInAppOnTaskBugChange = input.notifyInAppOnTaskBugChange;
	}
	if (input.notifyInAppOnTaskBlockedChange !== undefined) {
		obj.notifyInAppOnTaskBlockedChange = input.notifyInAppOnTaskBlockedChange;
	}
	if (input.notifyInAppOnTaskRepeatingChange !== undefined) {
		obj.notifyInAppOnTaskRepeatingChange = input.notifyInAppOnTaskRepeatingChange;
	}
	if (input.disableInAppNotifications) {
		obj.disableInAppNotifications = input.disableInAppNotifications;
	}
	if (input.lastSeenInAppNotification) {
		obj.lastSeenInAppNotification = input.lastSeenInAppNotification;
	}
	if (input.projectDeadlineNotificationPeriod) {
		obj.projectDeadlineNotificationPeriod = input.projectDeadlineNotificationPeriod;
	}
	if (input.taskDeadlineNotificationPeriod) {
		obj.taskDeadlineNotificationPeriod = input.taskDeadlineNotificationPeriod;
	}
	if (input.sendNewsletter) {
		obj.sendNewsletter = input.sendNewsletter;
	}

	if (input.language === null) {
		obj.language = null;
	} else if (input.language !== undefined) {
		obj.language = input.language;
	}
	if (input.unit4PersonId) {
		obj.unit4UserObject = input.unit4PersonId;
	}

	if (input.jiraCloudId) {
		obj.jiraCloudId = input.jiraCloudId;
	}

	if (input.jiraServerId) {
		obj.jiraServerId = input.jiraServerId;
	}
	if (input.startDate !== undefined) {
		obj.startDate = input.startDate;
	}
	if (input.endDate !== undefined) {
		obj.endDate = input.endDate;
	}

	return {
		updateViewer: {
			viewer: obj,
		},
	};
}

function commit(environment, input, onSuccess, onError, uploadables) {
	const changes = [];

	for (const key of Object.keys(input)) {
		if (input[key] === undefined) {
			continue;
		}

		changes.push(key);
	}

	tracking.trackEvent('Person Updated', {_Changed: changes});

	const variables = {...input};
	// ID is needed for mutations's optimistic response, but should not be included in the variables
	const variablesNoID = omit(variables, ['id', 'viewer']);

	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...variablesNoID}},
		uploadables,
		configs: getConfigs(),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit, mutationId: 'updateViewerMutation'};
